var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 39 39"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeWidth: 1.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38 19.5C38 29.717 29.717 38 19.5 38S1 29.717 1 19.5C1 9.282 9.283 1 19.5 1S38 9.282 38 19.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.993 30.008l-5.52 3.011a4.93 4.93 0 00-.886.631A18.42 18.42 0 0019.5 38c4.506 0 8.634-1.613 11.843-4.29a4.93 4.93 0 00-.973-.652l-5.911-2.955a2.254 2.254 0 01-1.246-2.017v-2.319c.166-.189.356-.432.559-.718a13.601 13.601 0 001.837-3.703 1.857 1.857 0 001.316-1.766v-2.476c0-.544-.241-1.031-.618-1.372v-3.578s.735-5.57-6.807-5.57c-7.542 0-6.807 5.57-6.807 5.57v3.578a1.847 1.847 0 00-.618 1.372v2.476c0 .652.343 1.225.855 1.556.619 2.694 2.238 4.631 2.238 4.631v2.262c0 .825-.45 1.584-1.175 1.979z"
  }))));
};
export default __webpack_public_path__ + "static/media/user.3cfa2e0a.svg";
export { SvgUser as ReactComponent };